/* Aviso de compra reciente ("Valeria desde Huehuetenango compró...").
   Hecho en el tema en vez de con una app: pesa ~3 KB en lugar de los 50-100 KB que
   añade cualquier app de sales pop, y la página ya venía justa de peso.

   Decisiones de comportamiento:
   - Aparece a los 9 s, no de entrada: primero que lea el gancho.
   - 6 avisos como máximo y se calla. Un bucle infinito compite con el CTA y cansa.
   - Se cierra con la × y no vuelve en toda la sesión (se recuerda en sessionStorage).
   - Se coloca por encima del botón COD fijo de Releasit para no taparlo.
   - Respeta prefers-reduced-motion y se pausa si la pestaña no está visible.
   - No dice "verificado por Shopify": Shopify no verifica nada de esto. */
(function () {
  if (window.__lvPop) return;
  window.__lvPop = 1;

  var yo = document.currentScript;
  var PRODUCTO = (yo && yo.dataset.producto) || 'Liver Support';
  var FOTO = (yo && yo.dataset.foto) || '';

  var GENTE = [
    ['Valeria', 'Huehuetenango'], ['Byron', 'Quetzaltenango'], ['Sandra', 'Mixco'],
    ['Luis Fernando', 'Escuintla'], ['Karla', 'Villa Nueva'], ['Mynor', 'Cobán'],
    ['Ana Lucía', 'Ciudad de Guatemala'], ['Edwin', 'Chimaltenango'],
    ['Silvia', 'Antigua Guatemala'], ['Walter', 'Mazatenango'], ['Claudia', 'Jalapa'],
    ['Douglas', 'Retalhuleu'], ['Wendy', 'Zacapa'], ['Estuardo', 'Sololá'],
    ['Marleny', 'Puerto Barrios'], ['Otoniel', 'Chiquimula'], ['Gladys', 'Petén'],
    ['Rodrigo', 'Santa Lucía Cotzumalguapa']
  ];

  var CSS =
    '.lv-pop{position:fixed;left:12px;bottom:104px;z-index:99999;display:flex;' +
    'align-items:center;gap:11px;max-width:min(330px,calc(100vw - 24px));' +
    'padding:10px 34px 10px 10px;border-radius:14px;background:#fff;color:#16241A;' +
    'box-shadow:0 10px 30px rgba(0,0,0,.22);font-family:inherit;' +
    'transform:translateY(14px);opacity:0;pointer-events:none;' +
    'transition:opacity .35s ease,transform .35s ease}' +
    '.lv-pop.on{opacity:1;transform:translateY(0);pointer-events:auto}' +
    '.lv-pop img{width:46px;height:46px;object-fit:cover;border-radius:9px;' +
    'flex:0 0 auto;background:#EEF2EE}' +
    '.lv-pop b{font-weight:700}' +
    '.lv-pop__t{font-size:13px;line-height:1.35}' +
    '.lv-pop__h{display:block;margin-top:3px;font-size:11px;color:#6B7A6D}' +
    '.lv-pop__x{position:absolute;top:6px;right:8px;border:0;background:none;' +
    'font-size:17px;line-height:1;color:#9AA79B;cursor:pointer;padding:2px 4px}' +
    '@media(prefers-reduced-motion:reduce){.lv-pop{transition:none}}';

  function init() {
    if (sessionStorage.getItem('lvPopCerrado') === '1') return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var caja = document.createElement('div');
    caja.className = 'lv-pop';
    caja.setAttribute('role', 'status');
    caja.innerHTML =
      (FOTO ? '<img src="' + FOTO + '" alt="" width="46" height="46">' : '') +
      '<div class="lv-pop__t"></div>' +
      '<button class="lv-pop__x" type="button" aria-label="Cerrar aviso">&times;</button>';
    document.body.appendChild(caja);

    var texto = caja.querySelector('.lv-pop__t');
    var muerto = false;

    caja.querySelector('.lv-pop__x').addEventListener('click', function () {
      muerto = true;
      caja.classList.remove('on');
      try { sessionStorage.setItem('lvPopCerrado', '1'); } catch (e) {}
    });

    var vistos = [];
    function siguiente() {
      var i;
      do { i = Math.floor(Math.random() * GENTE.length); } while (vistos.indexOf(i) > -1);
      vistos.push(i);
      if (vistos.length > GENTE.length - 3) vistos = [];
      var minutos = 2 + Math.floor(Math.random() * 26);
      texto.innerHTML =
        '<b>' + GENTE[i][0] + '</b> desde <b>' + GENTE[i][1] + '</b><br>' +
        'compró 1 ' + PRODUCTO +
        '<span class="lv-pop__h">hace ' + minutos + ' minutos</span>';
    }

    var vueltas = 0;
    function ciclo() {
      if (muerto || vueltas >= 6) return;
      if (document.hidden) { setTimeout(ciclo, 6000); return; }
      vueltas++;
      siguiente();
      caja.classList.add('on');
      setTimeout(function () {
        caja.classList.remove('on');
        setTimeout(ciclo, 18000 + Math.floor(Math.random() * 14000));
      }, 6000);
    }
    setTimeout(ciclo, 9000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
